import { FileEarmarkText } from "react-bootstrap-icons";
import { getFileIcon, formatSize, groupByContract, hexToRgba } from "./Utils";
import "./Upload.css";

const StatChip = ({ value, label }) => {
  return (
    <div className="review-step__stat-chip">
      <span className="review-step__stat-value">{value}</span>
      <span className="review-step__stat-label">{label}</span>
    </div>
  );
};

const FileRow = ({ file }) => {
  const icon = getFileIcon(file.name);
  return (
    <div className="review-contract-card__file">
      <span
        className="review-contract-card__file-badge"
        style={{ color: icon.color, background: hexToRgba(icon.color, 0.12) }}
      >
        {icon.label}
      </span>
      <span className="review-contract-card__file-name">{file.name}</span>
      {file.docType && (
        <span className="review-contract-card__doc-type">{file.docType}</span>
      )}
      <span className="review-contract-card__file-size">
        {formatSize(file.size)}
      </span>
    </div>
  );
};

const ContractCard = ({ contract, files }) => {
  return (
    <div className="review-contract-card">
      <div className="review-contract-card__header">
        <div className="review-contract-card__icon-box">
          <FileEarmarkText size={13} color="#fff" />
        </div>
        <div className="review-contract-card__meta">
          <div className="review-contract-card__name">
            {contract?.number}
            {contract?.providerNumber &&
            contract?.providerNumber !== contract?.number
              ? ` - ${contract?.providerNumber}`
              : ""}
          </div>
        </div>
        <span className="review-contract-card__count">{files.length}</span>
      </div>
      {files.map((file) => (
        <FileRow key={file.id} file={file} />
      ))}
    </div>
  );
};

export function Review({ assignments }) {
  const grouped = groupByContract(assignments);
  const contractCount = Object.keys(grouped).length;

  return (
    <div>
      <div className="review-step__stats">
        <StatChip value={assignments.length} label="total files" />
        <StatChip value={contractCount} label="contracts" />
      </div>

      <div className="review-step__grid">
        {Object.values(grouped).map(({ contract, files }) => (
          <ContractCard
            key={contract?.number ?? "__none"}
            contract={contract}
            files={files}
          />
        ))}
      </div>
    </div>
  );
}
